import React from 'react';
import PropTypes from 'prop-types';

const RatingAndReviewsWrapper = ({ children, href, onClick }) => {
  const hasClick = href || onClick;

  const classes =
    'flex items-center min-h-[16px] text-gray-light1 pr-[3px] !no-underline';

  return (
    <div className="flex justify-start">
      {hasClick ? (
        <a className={classes} onClick={onClick} href={href}>
          {children}
        </a>
      ) : (
        <div className={classes}>{children}</div>
      )}
    </div>
  );
};

RatingAndReviewsWrapper.propTypes = {
  children: PropTypes.node,
  href: PropTypes.string,
  onClick: PropTypes.func,
};

export default RatingAndReviewsWrapper;
